export type Language = "en" | "ja" | "th";

export const translations = {
  en: {
    ageVerification: {
      title: "Age Verification",
      description: "This experience contains simulated gaming mechanics.",
      confirm: "By continuing, you confirm that you are",
      ageRequirement: "18 years or older",
      underAge: "Under 18",
      overAge: "I'm 18+",
      error: "You must be 18 or older to access this content.",
      selectLanguage: "Select Language",
    },
    game: {
      credits: "Credits",
      draw: "Draw",
      collect: "Collect",
      close: "Close",
      insufficientCredits: "Insufficient Credits",
      insufficientCreditsDesc: "You need at least 100 credits to draw.",
      welcomeMessage: "Welcome to the MHD Lucky Draw! 🍾 Tap the golden button to try your luck, or ask me anything about our premium wines and spirits. You have 3 draws to reach 1,000 credits and win a bottle of Chandon!",
      askQuestion: "Ask a question...",
      typing: "Typing...",
      chatError: "My apologies, I'm having difficulty responding at the moment.",
    },
    prizes: {
      "1000 Credits": "1000 Credits",
      "Try Again": "Try Again",
      "500 Credits": "500 Credits",
      "Free Draw": "Free Draw",
      "GRAND PRIZE": "GRAND PRIZE",
      "250 Credits": "250 Credits",
      "Mystery": "Mystery",
      "No Luck": "No Luck",
    },
    champagne: {
      congratulations: "Congratulations!",
      reached: "You've reached",
      credits1000: "1,000 credits!",
      claimMessage: "Claim your complimentary bottle of Chandon champagne.",
      claimPrize: "Claim Your Prize",
      continuePlaying: "Continue Playing",
    },
  },
  ja: {
    ageVerification: {
      title: "年齢確認",
      description: "このコンテンツにはゲーム要素が含まれています。",
      confirm: "続行することで、あなたが",
      ageRequirement: "18歳以上",
      underAge: "18歳未満",
      overAge: "18歳以上です",
      error: "このコンテンツにアクセスするには18歳以上である必要があります。",
      selectLanguage: "言語を選択",
    },
    game: {
      credits: "クレジット",
      draw: "抽選",
      collect: "受け取る",
      close: "閉じる",
      insufficientCredits: "クレジット不足",
      insufficientCreditsDesc: "抽選するには100クレジット以上必要です。",
      welcomeMessage: "MHDラッキードローへようこそ！🍾 ゴールデンボタンをタップして運試し、またはプレミアムワインやスピリッツについて何でもお聞きください。3回の抽選で1,000クレジットに達すると、シャンドンのボトルが当たります！",
      askQuestion: "質問を入力...",
      typing: "入力中...",
      chatError: "申し訳ありません。現在、応答に問題が発生しています。",
    },
    prizes: {
      "1000 Credits": "1000クレジット",
      "Try Again": "もう一度",
      "500 Credits": "500クレジット",
      "Free Draw": "無料抽選",
      "GRAND PRIZE": "グランプリ",
      "250 Credits": "250クレジット",
      "Mystery": "ミステリー",
      "No Luck": "残念",
    },
    champagne: {
      congratulations: "おめでとうございます！",
      reached: "達成しました",
      credits1000: "1,000クレジット！",
      claimMessage: "シャンドンシャンパンのボトルをお受け取りください。",
      claimPrize: "賞品を受け取る",
      continuePlaying: "続ける",
    },
  },
  th: {
    ageVerification: {
      title: "การยืนยันอายุ",
      description: "ประสบการณ์นี้มีกลไกเกมจำลอง",
      confirm: "เมื่อดำเนินการต่อ คุณยืนยันว่าคุณ",
      ageRequirement: "อายุ 18 ปีขึ้นไป",
      underAge: "อายุต่ำกว่า 18",
      overAge: "ฉันอายุ 18+",
      error: "คุณต้องมีอายุ 18 ปีขึ้นไปเพื่อเข้าถึงเนื้อหานี้",
      selectLanguage: "เลือกภาษา",
    },
    game: {
      credits: "เครดิต",
      draw: "สุ่ม",
      collect: "รับรางวัล",
      close: "ปิด",
      insufficientCredits: "เครดิตไม่เพียงพอ",
      insufficientCreditsDesc: "คุณต้องมีเครดิตอย่างน้อย 100 เพื่อสุ่ม",
      welcomeMessage: "ยินดีต้อนรับสู่ MHD Lucky Draw! 🍾 แตะปุ่มทองเพื่อลองเสี่ยงโชค หรือถามเราเกี่ยวกับไวน์และสุราพรีเมียม คุณมี 3 ครั้งในการสุ่มเพื่อสะสม 1,000 เครดิตและชนะขวด Chandon!",
      askQuestion: "ถามคำถาม...",
      typing: "กำลังพิมพ์...",
      chatError: "ขออภัย ขณะนี้ฉันมีปัญหาในการตอบกลับ",
    },
    prizes: {
      "1000 Credits": "1000 เครดิต",
      "Try Again": "ลองอีกครั้ง",
      "500 Credits": "500 เครดิต",
      "Free Draw": "สุ่มฟรี",
      "GRAND PRIZE": "รางวัลใหญ่",
      "250 Credits": "250 เครดิต",
      "Mystery": "ลึกลับ",
      "No Luck": "ไม่โชคดี",
    },
    champagne: {
      congratulations: "ยินดีด้วย!",
      reached: "คุณถึงแล้ว",
      credits1000: "1,000 เครดิต!",
      claimMessage: "รับขวด Chandon แชมเปญฟรีของคุณ",
      claimPrize: "รับรางวัลของคุณ",
      continuePlaying: "เล่นต่อ",
    },
  },
} as const;

export function getTranslation(lang: Language) {
  return translations[lang];
}
